//TODO Add other themes
@import '../../../styles/variables-lm-corp';


:host {
  display: block;

  font-family: @font-family;
  font-size: @font-size;
  line-height: @line-height;
  color: @color-text;

  .header-actions {
    padding: @padding-container @padding-container 0 @padding-container;
    background-color: @liberty-gray-10;
  }
}
